import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { DiamondIcon } from 'foundations-assets/icons/components/DiamondIcon';
import { FavoriteHollowIcon } from 'foundations-assets/icons/components/FavoriteHollowIcon';
import { TrophyIcon } from 'foundations-assets/icons/components/TrophyIcon';
import unescapedText from 'I18n/utils/unescapedText';
export function getPartnerTierContent(listing) {
  const product = listing.products[0];
  if (product.productType !== 'SOLUTIONS_PARTNER_PROFILE') return undefined;
  switch (product.partnerTier) {
    case 'elite':
      return {
        badgeUse: 'lorax',
        icon: TrophyIcon,
        text: unescapedText('marketplaceStorefront.partnerTiers.elite')
      };
    case 'diamond':
      return {
        badgeUse: 'blue',
        icon: DiamondIcon,
        text: unescapedText('marketplaceStorefront.partnerTiers.diamond')
      };
    case 'platinum':
      return {
        badgeUse: 'koala',
        icon: CertificationIcon,
        iconColor: 'fill-accent-blue-default',
        text: unescapedText('marketplaceStorefront.partnerTiers.platinum')
      };
    case 'gold':
      return {
        badgeUse: 'koala',
        icon: FavoriteHollowIcon,
        text: unescapedText('marketplaceStorefront.partnerTiers.gold')
      };
    case 'none':
      return {
        badgeUse: 'koala',
        text: unescapedText('marketplaceStorefront.partnerTiers.partner')
      };
    default:
      return undefined;
  }
}